module.exports = "/images/icon_32_noofpax.png?57c69671f7b06041a6623e7086b69e78";